import {AxiosResponse} from "axios";

export function randomString(length: number = 5) {
    return Math.random().toString(36).substr(length);
}

export function generateFileName(prefix: string, fileName: string, separator = '-', length = 5) {
    const extraName = fileName.split('.').pop()
    const random = randomString(length)
    return `${prefix}${separator}${random}.${extraName}`
}

export function download(response: AxiosResponse<any>) {
    const filenameRegex = /filename[^;=\n]*="((['"]).*?\2|[^;\n]*)"/
    const matched = filenameRegex.exec(response.headers['content-disposition'])
    let fileName = ""
    if (matched) {
        fileName = matched[1]
    }
    const link = document.createElement('a')
    link.href = URL.createObjectURL(response.data)
    link.download = decodeURIComponent(fileName)
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    link.remove()
}